// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.public-profile-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.profile-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
}

.back-btn {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #495057;
  transition: all 0.2s ease;
}

.back-btn:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.profile-header h1 {
  margin: 0;
  color: #2c3e50;
  font-size: 28px;
  font-weight: 600;
}

.profile-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 30px;
  margin-bottom: 30px;
  display: flex;
  gap: 30px;
  align-items: flex-start;
}

.profile-avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  min-width: 150px;
}

.profile-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #e9ecef;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.profile-status {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.own-profile-badge {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.friend-badge {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.profile-info {
  flex: 1 1;
}

.profile-display h2 {
  margin: 0 0 20px 0;
  color: #2c3e50;
  font-size: 32px;
  font-weight: 700;
}

.profile-details {
  margin-bottom: 25px;
}

.profile-details p {
  margin: 8px 0;
  color: #495057;
  font-size: 16px;
}

.profile-details strong {
  color: #2c3e50;
  font-weight: 600;
}

.bio {
  margin: 15px 0;
}

.bio p {
  margin: 8px 0;
  line-height: 1.6;
  color: #6c757d;
  font-style: italic;
  background: #f8f9fa;
  padding: 12px;
  border-radius: 8px;
  border-left: 4px solid #007bff;
}

.profile-meta {
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #e9ecef;
}

.profile-meta p {
  font-size: 14px;
  color: #6c757d;
}

.profile-actions {
  margin-top: 25px;
}

.edit-profile-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 10px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.edit-profile-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.friend-action-btn {
  border: none;
  border-radius: 10px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-right: 10px;
}

.friend-action-btn.add-friend {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(17, 153, 142, 0.3);
}

.friend-action-btn.add-friend:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(17, 153, 142, 0.4);
}

.friend-action-btn.pending {
  background: #ffc107;
  color: #212529;
  cursor: not-allowed;
  opacity: 0.8;
}

.friend-action-btn.accept {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
}

.friend-action-btn.accept:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
}

.friend-action-btn.reject {
  background: linear-gradient(135deg, #dc3545 0%, #fd7e14 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
}

.friend-action-btn.reject:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
}

.friend-action-btn.remove-friend {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);
}

.friend-action-btn.remove-friend:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 117, 125, 0.4);
}

.friend-request-actions {
  display: flex;
  gap: 10px;
}

.edit-form {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 12px;
  border: 1px solid #e9ecef;
}

.form-group {
  margin-bottom: 20px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #2c3e50;
  font-weight: 600;
  font-size: 14px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.edit-actions {
  display: flex;
  gap: 15px;
  margin-top: 25px;
}

.save-btn {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  border-radius: 10px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
}

.save-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
}

.cancel-btn {
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cancel-btn:hover {
  background: #5a6268;
  transform: translateY(-1px);
}

.share-profile-section {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 30px;
  margin-bottom: 30px;
}

.share-profile-section h3 {
  margin: 0 0 15px 0;
  color: #2c3e50;
  font-size: 24px;
  font-weight: 600;
}

.share-profile-section p {
  margin: 0 0 20px 0;
  color: #6c757d;
  line-height: 1.6;
}

.share-link-container {
  display: flex;
  gap: 10px;
  align-items: center;
}

.share-link-input {
  flex: 1 1;
  padding: 12px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  background: #f8f9fa;
  color: #495057;
}

.copy-link-btn {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.copy-link-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

.profile-loading,
.profile-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.profile-error h2 {
  margin: 0 0 15px 0;
  color: #dc3545;
  font-size: 28px;
}

.profile-error p {
  margin: 0 0 25px 0;
  color: #6c757d;
  font-size: 16px;
}

.back-home-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 10px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
}

.back-home-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

/* Responsive Design */
@media (max-width: 768px) {
  .public-profile-container {
    padding: 15px;
  }
  
  .profile-card {
    flex-direction: column;
    text-align: center;
    padding: 20px;
  }
  
  .profile-avatar-section {
    min-width: auto;
  }
  
  .form-row {
    grid-template-columns: 1fr;
  }
  
  .share-link-container {
    flex-direction: column;
  }
  
  .share-link-input {
    margin-bottom: 10px;
  }
  
  .friend-request-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .friend-action-btn {
    margin: 5px 0;
    width: 100%;
    max-width: 200px;
  }
  
  .edit-actions {
    flex-direction: column;
  }
  
  .save-btn,
  .cancel-btn {
    width: 100%;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/PublicProfile.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".public-profile-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.profile-header {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.back-btn {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 10px 16px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #495057;\n  transition: all 0.2s ease;\n}\n\n.back-btn:hover {\n  background: #e9ecef;\n  border-color: #adb5bd;\n}\n\n.profile-header h1 {\n  margin: 0;\n  color: #2c3e50;\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.profile-card {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  padding: 30px;\n  margin-bottom: 30px;\n  display: flex;\n  gap: 30px;\n  align-items: flex-start;\n}\n\n.profile-avatar-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n  min-width: 150px;\n}\n\n.profile-avatar {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 4px solid #e9ecef;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.profile-status {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n}\n\n.own-profile-badge {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.friend-badge {\n  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.profile-info {\n  flex: 1;\n}\n\n.profile-display h2 {\n  margin: 0 0 20px 0;\n  color: #2c3e50;\n  font-size: 32px;\n  font-weight: 700;\n}\n\n.profile-details {\n  margin-bottom: 25px;\n}\n\n.profile-details p {\n  margin: 8px 0;\n  color: #495057;\n  font-size: 16px;\n}\n\n.profile-details strong {\n  color: #2c3e50;\n  font-weight: 600;\n}\n\n.bio {\n  margin: 15px 0;\n}\n\n.bio p {\n  margin: 8px 0;\n  line-height: 1.6;\n  color: #6c757d;\n  font-style: italic;\n  background: #f8f9fa;\n  padding: 12px;\n  border-radius: 8px;\n  border-left: 4px solid #007bff;\n}\n\n.profile-meta {\n  margin-top: 20px;\n  padding-top: 15px;\n  border-top: 1px solid #e9ecef;\n}\n\n.profile-meta p {\n  font-size: 14px;\n  color: #6c757d;\n}\n\n.profile-actions {\n  margin-top: 25px;\n}\n\n.edit-profile-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.edit-profile-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.friend-action-btn {\n  border: none;\n  border-radius: 10px;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-right: 10px;\n}\n\n.friend-action-btn.add-friend {\n  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);\n  color: white;\n  box-shadow: 0 4px 15px rgba(17, 153, 142, 0.3);\n}\n\n.friend-action-btn.add-friend:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(17, 153, 142, 0.4);\n}\n\n.friend-action-btn.pending {\n  background: #ffc107;\n  color: #212529;\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\n.friend-action-btn.accept {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);\n}\n\n.friend-action-btn.accept:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);\n}\n\n.friend-action-btn.reject {\n  background: linear-gradient(135deg, #dc3545 0%, #fd7e14 100%);\n  color: white;\n  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);\n}\n\n.friend-action-btn.reject:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);\n}\n\n.friend-action-btn.remove-friend {\n  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);\n  color: white;\n  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);\n}\n\n.friend-action-btn.remove-friend:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(108, 117, 125, 0.4);\n}\n\n.friend-request-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.edit-form {\n  background: #f8f9fa;\n  padding: 25px;\n  border-radius: 12px;\n  border: 1px solid #e9ecef;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  color: #2c3e50;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  font-size: 16px;\n  transition: border-color 0.3s ease;\n  box-sizing: border-box;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.edit-actions {\n  display: flex;\n  gap: 15px;\n  margin-top: 25px;\n}\n\n.save-btn {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);\n}\n\n.save-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);\n}\n\n.cancel-btn {\n  background: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 10px;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.cancel-btn:hover {\n  background: #5a6268;\n  transform: translateY(-1px);\n}\n\n.share-profile-section {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  padding: 30px;\n  margin-bottom: 30px;\n}\n\n.share-profile-section h3 {\n  margin: 0 0 15px 0;\n  color: #2c3e50;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.share-profile-section p {\n  margin: 0 0 20px 0;\n  color: #6c757d;\n  line-height: 1.6;\n}\n\n.share-link-container {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.share-link-input {\n  flex: 1;\n  padding: 12px;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  font-size: 14px;\n  background: #f8f9fa;\n  color: #495057;\n}\n\n.copy-link-btn {\n  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.copy-link-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);\n}\n\n.profile-loading,\n.profile-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.error-icon {\n  font-size: 48px;\n  margin-bottom: 20px;\n}\n\n.profile-error h2 {\n  margin: 0 0 15px 0;\n  color: #dc3545;\n  font-size: 28px;\n}\n\n.profile-error p {\n  margin: 0 0 25px 0;\n  color: #6c757d;\n  font-size: 16px;\n}\n\n.back-home-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.back-home-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .public-profile-container {\n    padding: 15px;\n  }\n  \n  .profile-card {\n    flex-direction: column;\n    text-align: center;\n    padding: 20px;\n  }\n  \n  .profile-avatar-section {\n    min-width: auto;\n  }\n  \n  .form-row {\n    grid-template-columns: 1fr;\n  }\n  \n  .share-link-container {\n    flex-direction: column;\n  }\n  \n  .share-link-input {\n    margin-bottom: 10px;\n  }\n  \n  .friend-request-actions {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .friend-action-btn {\n    margin: 5px 0;\n    width: 100%;\n    max-width: 200px;\n  }\n  \n  .edit-actions {\n    flex-direction: column;\n  }\n  \n  .save-btn,\n  .cancel-btn {\n    width: 100%;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
